import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faImage, faTicket } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-default-image',
  imports: [
    FaIconComponent,
    CommonModule
],
  templateUrl: './default-image.component.html',
  styleUrl: './default-image.component.scss'
})
export class DefaultImageComponent {
faTicket = faTicket;
faImage = faImage

@Input() element!:string ; 

}
